export const shouldLoad = () => !!document.querySelector('.klt-settings-block--order-overview');
